// extracted by mini-css-extract-plugin
export default {"container":"Unsubscribe_container__DN8nz","txtMsg":"Unsubscribe_txtMsg__li5DV","card":"Unsubscribe_card__wwdgw"};